import firebase from '../util/firebase';
import GeoFire from 'geofire';
import {notification} from '../util/toast';
const URL = 'alertas-localizacao';
let geofire, query;

export const alertasIsLoading = (isLoading) => ({ type: 'ALERTA_IS_LOADING', isLoading });
export const alertaEntered = (alerta) => ({ type: 'ALERTA_ENTERED', alerta });
export const alertaExited = (alerta) => ({ type: 'ALERTA_EXITED', alerta });
export const resetAlertas = () => ({type: 'RESET_ALERTAS'});
export const alertaMoved = (alerta) => ({ type: 'ALERTA_MOVED', alerta });
export const alertaFetchError = (error) => ({ type: 'ALERTA_FETCH_ERROR', error });
export const toggleListeningAlertas = (isListening) => ({ type: 'TOGGLE_LISTENING_ALERTAS', isListening });
export const selecionaToastAlerta = (alerta) => ({type: 'SELECIONA_TOAST_ALERTA', alerta});
export const atualizaLocalizacaoAlertas = (criteria) => (dispatch) => {
  return query &&
    typeof query.updateCriteria === 'function' &&
    query.updateCriteria(criteria);
};

export const registerAlertasListeners = () => (dispatch, getState) =>  {
  const {raio, localizacao} = getState();
  const ref = firebase.database().ref(URL);
  geofire = new GeoFire(ref);
  query = geofire.query({
    center: localizacao,
    radius: raio
  });
  let alertasIds = [];
  
  dispatch(toggleListeningAlertas(true));
  
  query.on('key_entered', (id, localizacao, distancia) => {
    var alert = false;
    if(getState().alertas.length > 0){
      alert = true
    }
    firebase.database().ref(`alertas-grupos/${id}`).once('value')
    .then((snap) => {
      firebase.database().ref(`alertas/${snap.val()}/${id}`).once('value')
      .then(snap => {
        if (snap.val()) {
          const tipo = snap.val().tipo;
          const timestamp = snap.val().timestamp;
          const data = new Date(snap.val().timestamp * 1000);
          const endereco = snap.val().localizacao;
          firebase.database().ref(`usuarios/${snap.val().membroKey}`).once('value')
          .then(snap => {
            const usuario = snap.val();
            if(alert){
              notification({usuario, tipo, localizacao}, 'error')
            }
            console.log("===> ALERT ID " + id);
            if (alertasIds.indexOf(id) == -1) {
              alertasIds.push(id);
              dispatch(alertaEntered({id, localizacao, distancia, tipo, data, timestamp, usuario, endereco}));
            }
          })  
        }
      });
    });
  });

  query.on('key_exited', (id, localizacao, distancia) =>  dispatch(alertaExited({id, localizacao, distancia})) );
  
  query.on('key_moved', (id, localizacao, distancia) =>  dispatch(alertaMoved({id, localizacao, distancia})) );
};

export const unregisterAlertasListeners = () => (dispatch) => {
  firebase.database().ref(URL).off('value');
  dispatch(toggleListeningAlertas(false));
};
export const toggleAlertas = (filtro) => ({type: 'TOGGLE_ALERTAS', filtro});



// WEBPACK FOOTER //
// ./src/actions/alertas.js